import { INIT_PAYMENT } from './actions';
import { PaymentConfig } from './types';

const initialState: PaymentConfig = null;

export function paymentReducer(state = initialState, action: any): PaymentConfig {
  switch (action.type) {
    case INIT_PAYMENT: {
      return action.payload;
    }
    default:
      return state;
  }
}
